import { Box, Input } from '@chakra-ui/react'
import Icon from '../shared/icons'

const Search = ({ setSearch }: { setSearch: (value: string) => void }) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value
		setSearch(value)
	}
	return (
		<Box
			w={{ base: 'full', sm: 'auto' }}
			display='flex'
			alignItems='center'
			bg='white'
			pl='4'
			pr='4'
			pt='0.5'
			pb='0.5'
			borderRadius='md'
			boxShadow='sm'
			ml={{ base: '0', sm: '4' }}
			mr={{ base: '0', sm: '4' }}
			mt={{ base: '4', sm: '0' }}
			mb={{ base: '4', sm: '0' }}
		>
			<Input
				placeholder='Buscar productos...'
				w={{ base: 'full', sm: '15vw' }}
				bg='transparent'
				onChange={handleChange}
				padding='2'
				border='none'
				outline='none'
			/>

			<Icon icon='search' color='dark' size='xl' aria_label='shopping cart' />
		</Box>
	)
}

export default Search
